module.exports = __webpack_public_path__ + "static/img/signature.1bed022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/signature.png
// module id = JOWC
// module chunks = 150